import React, { useState, useEffect } from 'react';

import { Tabs, Tab, Box, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Container, Button } from 'styles/admin';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import { QUESTION_MENU_OPTIONS } from 'constants/ProjectConstants';

import { getQuestions } from 'services/reviews';
import { showErrorSnackbar } from 'services/snackbar';

import TooltipInfo from 'uiToolkit/TooltipInfo';
import { Typography17 } from 'uiToolkit/Typography';
import { TextHeader2 } from 'uiToolkitV1/Typography';

import QuestionsList from './QuestionsList';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Questions = ({
  source = 'review',
  showQuestionDetails,
  updatedQuestion,
  competencies = [],
  drivers = [],
  subheadingEl = '',
  info = null,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [activeQuestions, setActiveQuestions] = useState([]);
  const [sampleQuestions, setSampleQuestions] = useState([]);
  const [archivedQuestions, setArchivedQuestions] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);

  const getUserQuestions = ({ label, questionsSetter }) => {
    setLoading(true);
    questionsSetter([]);
    getQuestions({ offset: 0, limit: 2000, label, source })
      .then((res) => {
        if (res.length) {
          questionsSetter(res);
        }
      })
      .catch((err) => {
        dispatch(showErrorSnackbar(err.message || 'Sorry, unable to fetch the questions!'));
      })
      .finally(() => setLoading(false));
  };

  const getData = (currentTab) => {
    if (currentTab === 0) {
      getUserQuestions({ label: null, questionsSetter: setActiveQuestions });
    } else if (currentTab === 1) {
      getUserQuestions({ label: 'SAMPLE', questionsSetter: setSampleQuestions });
    } else if (currentTab === 2) {
      getUserQuestions({ label: 'ARCHIVE', questionsSetter: setArchivedQuestions });
    }
  };

  useEffect(() => {
    getData(currentTab);
  }, [currentTab]);

  useEffect(() => {
    if (updatedQuestion) {
      getData(currentTab);
    }
  }, [updatedQuestion]);

  const onNewClick = () => {
    dispatch(showQuestionDetails({ questionId: 0, action: 'create', source, history }));
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <StyledContainer>
      <VerticallyAlignedFlexContainer style={{ justifyContent: 'space-between' }}>
        <div>
          <VerticallyAlignedFlexContainer bottomGutter={2}>
            <TextHeader2 bold>Question Library</TextHeader2>
            {info && <TooltipInfo leftGutter={1} title={info.title} linkUrl={info.url} />}
          </VerticallyAlignedFlexContainer>

          <Typography17>{subheadingEl}</Typography17>
        </div>
        <Button blue size="large" onClick={onNewClick} disabled={loading}>
          Add Question
        </Button>
      </VerticallyAlignedFlexContainer>

      <FormContainer>
        <StyledTabs value={currentTab} onChange={handleTabChange}>
          <StyledTab label="Your Questions" />
          <StyledTab label="Sample" />
          <StyledTab label="Archived" />
        </StyledTabs>
        <TabPanel value={currentTab} index={0}>
          <QuestionsList
            source={source}
            questions={activeQuestions}
            loading={loading}
            menuOptions={QUESTION_MENU_OPTIONS.active}
            updateData={() => getData(0)}
            competencies={competencies}
            drivers={drivers}
            noDataMessage="No active questions were found"
            noDataSubMessage='click on "Add Question" to get started'
          />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <QuestionsList
            source={source}
            questions={sampleQuestions}
            loading={loading}
            menuOptions={QUESTION_MENU_OPTIONS.sample}
            updateData={() => getData(1)}
            competencies={competencies}
            drivers={drivers}
            rowClickable={false}
          />
        </TabPanel>
        <TabPanel value={currentTab} index={2}>
          <QuestionsList
            source={source}
            questions={archivedQuestions}
            loading={loading}
            menuOptions={QUESTION_MENU_OPTIONS.archived}
            updateData={() => getData(2)}
            competencies={competencies}
            drivers={drivers}
            noDataMessage="No archived questions were found"
          />
        </TabPanel>
      </FormContainer>
    </StyledContainer>
  );
};

const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid #eaeaea;
  .MuiTabs-indicator {
    height: 3px;
    background: #3a8ee9 !important;
  }
`;

const StyledTab = styled(Tab)`
  font-size: 1rem;
  min-width: auto;
  margin-left: 1.5rem;
  padding: 14px 12px 12px 12px;
  .MuiTab-wrapper {
    text-transform: initial;
  }
  &.Mui-selected {
    font-weight: 600;
    color: #3a8ee9;
  }
`;

const StyledContainer = styled(Container)`
  padding: 16px;
  height: max-content;
`;

const FormContainer = styled.div`
  background: white;
  border: 1px solid #eaeaea;
  margin-top: 1.5rem;
  margin-bottom: 2.5rem;
`;

export default withRouter(Questions);
